import React from 'react';

import { Avatar } from 'antd';
import _ from 'lodash';

// import PropTypes from 'prop-types';

import S from './styles';

const { Meta } = S.ItemSelected;

function ItemSelected({ item, title }) {
  if (!_.isEmpty(item)) {
    return (
      <S.ItemSelected>
        <Meta avatar={<Avatar src={item.logo} />} title={item.title} />
      </S.ItemSelected>
    );
  }
  return null;
}

// ItemSelected.propTypes = {
//   item: PropTypes.objectOf({
//     title: PropTypes.string,
//   }),
// };

export default ItemSelected;
